<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>服务者详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="height: 1000px;overflow:auto">
      <div style="display: flex; justify-content: space-between">
        <div style="font-size: 18px; color: black">
          <i
            class="el-icon-collection-tag"
            style="color: #606266; font-size: 18px; color: black"
          />
          <span class="font-small">服务者概况信息</span>
        </div>

        <div style="text-align: right">
          <div style="display: inline-block" v-per="'shifoulahei'">
            不拉黑
            <el-switch
              v-model="blacklistValue"
              active-color="#4A93CE"
              inactive-color="#DFDFDF"
              @change="blacklistValueChange"
            >
            </el-switch>
            拉黑
          </div>
          <el-button
            type="primary"
            v-per="'xiugaifuwuxinxi'"
            icon="el-icon-edit"
            @click="editWorkerInfo(false)"
            >修改服务信息
          </el-button>
          <el-button
            type="primary"
            v-per="'xiugaixinxi'"
            icon="el-icon-warning"
            @click="editWorkerInfo(true)"
            >修改信息
          </el-button>
          <el-button
            type="primary"
            v-per="'updateSource'"
            icon="el-icon-warning"
            @click="updateSource()"
            >修改来源
          </el-button>

          <el-button
            type="primary"
            v-if="servantInfo.healthCertificate != 1"
            icon="el-icon-upload"
            @click="addhealthOrSKill(servantInfo.id, 1)"
            >上传健康证
          </el-button>
          <el-button
            type="primary"
            icon="el-icon-warning"
            @click="showWorkerAddress()"
            >修改服务位置
          </el-button>
        </div>
      </div>

      <div class="table-layout">
        <el-row>
          <el-col :span="3" class="table-cell-title">服务者编号</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.workerNo
          }}</el-col>
          <el-col :span="3" class="table-cell-title">服务者名称</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.workerName
          }}</el-col>
          <el-col :span="3" class="table-cell-title">联系电话</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.workerTel
          }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">备用手机1</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.workerTel1
          }}</el-col>
          <el-col :span="3" class="table-cell-title">备用手机2</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.workerTel2
          }}</el-col>
          <el-col :span="3" class="table-cell-title">服务位置</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.servicePosition
          }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">城市-服务渠道</el-col>
          <el-col :span="5" class="table-cell"
            >{{ servantInfo.cityName }}-{{
              servantInfo.serviceChannel
                ? serviceChannels[servantInfo.serviceChannel]
                : ""
            }}
          </el-col>

          <el-col :span="3" class="table-cell-title">服务站</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.cityDto.stationName
          }}</el-col>

          <el-col :span="3" class="table-cell-title">紧急联系人信息</el-col>
          <el-col :span="5" class="table-cell"
            >{{ servantInfo.emergencyContact }}，{{
              servantInfo.emergencyTel
            }}</el-col
          >
        </el-row>

        <el-row>
          <el-col :span="3" class="table-cell-title">身份证号码</el-col>
          <el-col :span="5" class="table-cell"
            >{{ servantInfo.workerIdcard }}（{{ servantInfo.gender }}）</el-col
          >
          <el-col :span="3" class="table-cell-title">籍贯</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.nativePlace
          }}</el-col>
          <el-col :span="3" class="table-cell-title">服务者来源</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.sourceRelationName
          }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">服务者工种</el-col>
          <el-col :span="5" class="table-cell"
            >{{ servantInfo.buzLine | filterWorkerType(servantInfo.buzLine) }}
          </el-col>
          <el-col :span="3" class="table-cell-title">银行卡</el-col>
          <el-col :span="5" class="table-cell">{{ servantInfo.bankNo }}</el-col>

          <el-col :span="3" class="table-cell-title">银行卡开户行</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.bankOfDeposit
          }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="3" class="table-cell-title">师傅资格</el-col>
          <el-col :span="5" class="table-cell">
            {{ servantInfo.isMaster ? "有" : "无" }}
            <el-button
              type="warning"
              size="mini"
              @click="cancelzg"
              v-if="servantInfo.isMaster"
              >取消资格
            </el-button>
          </el-col>
          <el-col :span="3" class="table-cell-title">师傅</el-col>
          <el-col :span="5" class="table-cell">{{
            workerMentor.masterWorkerName
          }}</el-col>
          <el-col :span="3" class="table-cell-title">徒弟</el-col>
          <el-col :span="5" class="table-cell">
            <span v-for="(item, index) in apprenticeList" :key="index">{{
              item.workerName
            }}</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">保底期限</el-col>
          <el-col :span="5" class="table-cell" style="padding-top: 3px">
            {{ formateTime(servantInfo.guaranteeStart) }} <br />{{
              formateTime(servantInfo.guaranteeEnd)
            }}
          </el-col>
          <el-col :span="3" class="table-cell-title">保底金额</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.guaranteeAmount
          }}</el-col>
          <el-col :span="3" class="table-cell-title">是否复职</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.reinstated == 1 ? "是" : "否"
          }}</el-col>
        </el-row>

        <el-row>
          <el-col :span="3" class="table-cell-title">服务单分配</el-col>
          <el-col :span="5" class="table-cell"
            >{{
              servantInfo.serviceOrderAllot == 2
                ? "距离优先-可跨区"
                : "距离优先-不可跨区"
            }}
          </el-col>
          <el-col :span="3" class="table-cell-title">休息日</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.restDay
          }}</el-col>
          <el-col :span="3" class="table-cell-title">户口类型/社保情况</el-col>
          <el-col :span="5" class="table-cell"
            >{{ residenceTypeMap[servantInfo.residenceType] }}
            {{ socialSecurityMap[servantInfo.socialSecurity] }}
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3" class="table-cell-title">是否特批</el-col>
          <el-col :span="5" class="table-cell">{{
            servantInfo.specialRecu == true ? "是" : "否"
          }}</el-col>
          <el-col :span="3" class="table-cell-title">上线凭证</el-col>
          <el-col :span="5" class="table-cell">
            <el-image
              :preview-src-list="getsplit(servantInfo.emailUrl)"
              :src="getsplitOne(servantInfo.emailUrl)"
              style="height: 36px"
            />
          </el-col>
          <el-col :span="3" class="table-cell-title">标签</el-col>
          <el-col :span="5" class="table-cell">{{ servantInfo.tag }}</el-col>
        </el-row>
        <!-- 0未认证，1认证成功，2认证失败 -->
        <el-row>
          <el-col :span="3" class="table-cell-title">状态</el-col>
          <el-col :span="21" class="table-cell" style="display: flex"
            >当前状态：
            <el-tag
              :type="servantInfo.state == 2 ? 'success' : 'warning'"
              effect="dark"
            >
              {{ workerState[servantInfo.state] }} </el-tag
            >&nbsp;&nbsp;&nbsp;背调结果：<span
              :style="servantInfo.backInvestigate ? 'color:blue' : 'color:red'"
              :title="servantInfo.backInvestigateInfo"
              >{{
                workerInvestigate.resultScore < 60 ? "未通过" : "通过"
              }}；</span
            >&nbsp;&nbsp;健康证：<span style="color: red">{{
              healthState[servantInfo.healthCertificate]
            }}</span
            >&nbsp;&nbsp;实名认证：
            <span
              :style="
                servantInfo.faceCheck == 0 || servantInfo.faceCheck == 2
                  ? 'color:red'
                  : 'color:blue'
              "
              >{{
                servantInfo.faceCheck == 2
                  ? "认证失败"
                  : servantInfo.faceCheck == 1
                  ? "认证成功"
                  : "未认证"
              }}</span
            >
            <span
              style="
                font-size: 12px;
                color: rgb(170, 170, 170);
                margin-left: 20px;
              "
            >
              <i
                class="el-icon-warning-outline"
              />上线后背调、健康证通过即可接单</span
            >
          </el-col>
        </el-row>
      </div>
      <!-- <el-form :inline="true" size="small" v-model="belongForm" style="margin-top:15px">
          <el-form-item label="服务者归属">
              <el-select v-model="belongForm.workerBelongId" clearable placeholder="请选择服务者归属" filterable>
                  <el-option v-for="(item,index) in supplierList" :key="index" :label="item.franchiseeName" :value="item.id"></el-option>
              </el-select>
          </el-form-item>

          <el-form-item label="选择对谁可见">
              <el-select v-model="belongForm.workerBelongId" clearable placeholder="请选择选择对谁可见" filterable>
                  <el-option v-for="(item,index) in supplierList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
          </el-form-item>
          <el-button type="primary" icon="el-icon-edit" @click="handleOffice()">更新</el-button>
          <span style="font-size: 12px;color: rgb(170, 170, 170);margin-left:20px"><i class="el-icon-warning-outline" /> 选择对方可见后，对方即可匹配此保姆；不操作仅归属者可见</span>

      </el-form> -->
      <!-- <el-button type="text" style="position: absolute;right: 50px;" icon="el-icon-date">查看档期</el-button> -->
      <br />
      <el-tabs style="height: 320px" v-model="activeTab">
        <el-tab-pane label="基本信息" name="1">
          <div class="table-layout">
            <el-row>
              <el-col :span="3" class="table-cell-title">身高</el-col>
              <el-col :span="5" class="table-cell">{{
                servantInfo.height
              }}</el-col>
              <el-col :span="3" class="table-cell-title">体重</el-col>
              <el-col :span="5" class="table-cell">{{
                servantInfo.weight
              }}</el-col>
              <el-col :span="3" class="table-cell-title">上线时间</el-col>
              <el-col :span="5" class="table-cell">{{
                formateTime(servantInfo.createTime)
              }}</el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="table-cell-title">民族</el-col>
              <el-col :span="5" class="table-cell">{{
                servantInfo.nation
              }}</el-col>
              <el-col :span="3" class="table-cell-title">身份证(人像面)</el-col>
              <el-col :span="5" class="table-cell" style="padding: 2px">
                <el-image
                  :preview-src-list="[servantInfo.idcardFront]"
                  :src="servantInfo.idcardFront"
                  style="height: 36px"
                />
                <el-button
                  type="text"
                  style="float: right; color: red"
                  icon="el-icon-edit"
                  @click="updateIdcard"
                  >修改身份证</el-button
                >
              </el-col>
              <el-col :span="3" class="table-cell-title">身份证(国徽面)</el-col>
              <el-col :span="5" class="table-cell" style="padding: 2px">
                <el-image
                  :preview-src-list="[servantInfo.idcardBack]"
                  :src="servantInfo.idcardBack"
                  style="height: 36px"
                />
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="table-cell-title">健康证</el-col>
              <el-col :span="5" class="table-cell" style="padding: 2px 12px">
                <span
                  style="color: red"
                  v-if="servantInfo.healthCertificate != 1"
                  >{{ healthState[servantInfo.healthCertificate] }}</span
                >
                <el-image
                  :preview-src-list="[servantInfo.healthUrl]"
                  :src="servantInfo.healthUrl"
                  style="height: 36px"
                />
              </el-col>
              <el-col :span="3" class="table-cell-title">学历</el-col>
              <el-col :span="5" class="table-cell">{{
                servantInfo.education
              }}</el-col>
              <el-col :span="3" class="table-cell-title">头像</el-col>
              <el-col :span="5" class="table-cell">
                <el-image
                  :preview-src-list="[servantInfo.headPic]"
                  :src="servantInfo.headPic"
                  style="height: 36px"
                />
                <el-image
                  :preview-src-list="[servantInfo.headPicRuyi]"
                  :src="servantInfo.headPicRuyi"
                  style="height: 36px"
                />
                <el-button
                  type="text"
                  style="float: right"
                  icon="el-icon-edit"
                  @click="goUpdateHeadPic"
                  >修改头像
                </el-button>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="3" class="table-cell-title">照片信息</el-col>
              <el-col :span="13" class="table-cell">
                <span>头像</span>
                <el-image
                  v-for="(item, index) in getPersonImage()"
                  :key="index"
                  :src="item"
                  :preview-src-list="[item]"
                  style="height: 36px"
                ></el-image>
                <span>个人照片</span>
                <el-image
                  :preview-src-list="[servantInfo.headPic]"
                  :src="servantInfo.headPic"
                  style="height: 36px"
                ></el-image>
                <span>培训照片</span>
                <el-image
                  :preview-src-list="[servantInfo.trainingImg]"
                  :src="servantInfo.trainingImg"
                  style="height: 36px"
                ></el-image>
                <el-button
                  type="text"
                  style="float: right"
                  icon="el-icon-edit"
                  @click="goUpdateHeadPic"
                  >修改照片
                </el-button>
              </el-col>
              <el-col :span="3" class="table-cell-title"
                >综合星级<!--商家运营 servantInfo.workerManager --></el-col
              >
              <el-col :span="5" class="table-cell">{{
                servantInfo.scoreLevel
              }}</el-col>
            </el-row>
            <div>
              <br />
              <el-row
                ><span style="font-weight: bold; font-size: 18px"
                  >证件详情</span
                ></el-row
              >
              <el-button
                type="primary"
                style="float: right"
                icon="el-icon-edit"
                @click="addhealthOrSKill(servantInfo.id)"
                >上传(健康证/证书-花王-如逸)
              </el-button>
              <el-table
                :data="certificate"
                border
                style="width: 100%"
                class="table"
              >
                <el-table-column
                  prop="certificateName"
                  label="证件名称"
                ></el-table-column>
                <el-table-column prop="type" label="类型">
                  <template slot-scope="scope">{{
                    scope.row.type == 1 ? "健康证" : "技能证书"
                  }}</template>
                </el-table-column>
                <el-table-column
                  prop="certificateNo"
                  label="证件编号"
                ></el-table-column>
                <el-table-column
                  prop="issuanceDate"
                  :formatter="dateFormatA"
                  label="发证日期"
                >
                </el-table-column>
                <el-table-column prop="expirationDateStart" label="有效期">
                  <template slot-scope="scope">
                    {{ formateTime(scope.row.expirationDateStart) }} 至
                    {{ formateTime(scope.row.expirationDateEnd) }}
                  </template>
                </el-table-column>
                <el-table-column prop="certificateFileUrl" label="图片">
                  <template slot-scope="scope">
                    <el-image
                      :preview-src-list="[scope.row.certificateFileUrl]"
                      :src="scope.row.certificateFileUrl"
                      style="height: 36px"
                    />
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                  <template slot-scope="scope">
                    <el-button type="text" @click="delSkillCert(scope.row)"
                      >删除证书</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="2">
          <div slot="label" @click="goMentor">师徒关系</div>
        </el-tab-pane>

        <el-tab-pane label="薪资记录" name="3">
          <div slot="label" @click="goSalary">薪资记录</div>
          <el-table :data="salary" border style="width: 100%" class="table">
            <el-table-column prop="cityName" label="月份"></el-table-column>
            <el-table-column prop="workerName" label="薪资"></el-table-column>
            <el-table-column prop="gender" label="工单计提"></el-table-column>
            <el-table-column prop="gender" label="保底薪资"></el-table-column>
            <el-table-column prop="gender" label="复购"></el-table-column>
            <el-table-column
              prop="workerIdcard"
              width="150"
              label="其他"
            ></el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="物料领取" name="4">
          <div slot="label" @click="goWmsorderCenter">物料领取</div>
          <el-table :data="wmsOrder" border style="width: 100%" class="table">
            <el-table-column prop="cityName" label="购买商品"></el-table-column>
            <el-table-column
              prop="workerName"
              label="下单时间"
            ></el-table-column>
            <el-table-column
              prop="gender"
              width="60"
              label="金额"
            ></el-table-column>
            <el-table-column
              prop="workerIdcard"
              width="150"
              label="订单状态"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="住宿" name="5">
          <div slot="label" @click="goDormStaff">住宿</div>
        </el-tab-pane>
      </el-tabs>

      <!-- <div style="margin:10px 0;text-align:center" v-if="servantInfo.handlerId==curHandlerId">
  <el-button type="primary" icon="el-icon-edit" @click="handleFollow()">添加跟进</el-button>      <el-button type="primary" v-if="servantInfo.state!=3&&servantInfo.state!=4" icon="el-icon-close" @click="handleLoss()">流失</el-button>
  <el-button type="primary" v-if="servantInfo.state!=3&&servantInfo.state!=4" icon="el-icon-key" @click="handleOffice()">发起上线</el-button>
</div> -->
    </el-card>

    <el-dialog
      title="信息修改"
      :visible.sync="showEdit"
      width="800px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        label-width="100px"
        :inline="true"
        :model="editInfo"
        ref="editInfo"
        :rules="editInfo_rules"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="姓名" prop="workerName">
              <el-input
                :disabled="!openEditName"
                v-model="editInfo.workerName"
                style="width: 150px"
              ></el-input>
            </el-form-item>
            <el-button
              v-per="'xiugaimingzi'"
                  type="text"
                  style="float: right" 
                  @click="goUpdateName()"
                  >开启修改名字
                </el-button>
          </el-col>

          <el-col :span="12">
            <el-form-item label="城市" prop="cityId">
              <el-select
                v-model="editInfo.cityId"
                @change="selectCity"
                :disabled="ishz"
                placeholder="请选择城市"
                filterable
                style="width: 250px"
              >
                <el-option
                  v-for="(item, index) in cityList"
                  :key="index"
                  :label="item.cityName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="服务站" prop="stationId">
              <el-select
                v-model="editInfo.stationId"
                :disabled="ishz"
                style="width: 250px"
                placeholder="请选择服务站"
                filterable
              >
                <template v-for="(item, index) in allStationList">
                  <el-option
                    :key="index"
                    v-if="item.cityId == editInfo.cityId"
                    :label="item.stationName"
                    :value="item.id"
                  ></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务者标签" prop="tag">
              <el-select
                v-model="editInfo.tags"
                style="width: 250px"
                placeholder="请选择"
                multiple
                filterable
              >
                <el-option
                  v-for="(item, idx) in commutilData.tagsList"
                  :key="idx"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="保底金额">
              <el-input
                :disabled="ishz"
                type="number"
                style="width: 250px"
                v-model="editInfo.guaranteeAmount"
                placeholder
                clearable
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="保底期限">
              <el-date-picker
                :disabled="ishz"
                style="width: 250px"
                v-model="editInfo.guaranteeDate"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                :picker-options="{}"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="户口">
              <el-select
                v-model="editInfo.residenceType"
                style="width: 250px"
                placeholder="请选择户口"
                filterable
              >
                <el-option
                  v-for="(item, index) in residenceTypeMap"
                  :key="index"
                  :label="item"
                  :value="index"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="社保">
              <el-select
                v-model="editInfo.socialSecurity"
                style="width: 250px"
                placeholder="请选择社保"
                filterable
              >
                <el-option
                  :disabled="editInfo.residenceType != 2"
                  label="社保"
                  :value="1"
                ></el-option>
                <el-option
                  :disabled="editInfo.residenceType != 1"
                  label="新农保"
                  :value="2"
                ></el-option>
                <el-option
                  :disabled="editInfo.residenceType != 2"
                  label="已退休"
                  :value="3"
                ></el-option>
                <el-option label="无" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="休息日" prop="restDay">
          <el-checkbox-group v-model="editInfo.restDays">
            <el-checkbox label="周一" name="周一"></el-checkbox>
            <el-checkbox label="周二" name="周二"></el-checkbox>
            <el-checkbox label="周三" name="周三"></el-checkbox>
            <el-checkbox label="周四" name="周四"></el-checkbox>
            <el-checkbox label="周五" name="周五"></el-checkbox>
            <el-checkbox label="周六" name="周六"></el-checkbox>
            <el-checkbox label="周日" name="周日"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-row>
          <el-col :span="12">
            <el-form-item label="接单方式" prop="serviceOrderAllot">
              <el-select
                v-model="editInfo.serviceOrderAllot"
                style="width: 250px"
                placeholder="请选择"
                filterable
              >
                <el-option :value="1" label="距离优先-不可跨区" />
                <el-option :value="2" label="距离优先-可跨区" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="服务渠道" prop="serviceChannel">
              <el-select
                v-model="editInfo.serviceChannel"
                style="width: 250px"
                placeholder="请选择"
                filterable
              >
                <el-option :value="1" label="盒马" />
                <el-option :value="2" label="私域" />
                <el-option :value="3" label="公用" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="业务线" prop="buzLine">
              <el-select
                v-model="editInfo.buzLine"
                style="width: 250px"
                placeholder="请选择"
                filterable
              >
                <el-option
                  v-for="(item, index) in workTypes"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学历">
              <el-select
                v-model="editInfo.education"
                :disabled="!ishz"
                style="width: 250px"
                placeholder="请选择"
                filterable
              >
                <template v-for="(item, index) in educationList">
                  <el-option :label="item" :value="item"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="商家运营" prop="workerManagerId">
              <el-select
                v-model="editInfo.workerManagerId"
                style="width: 250px"
                placeholder="请选择商家运营"
                filterable
              >
                <el-option
                  v-for="(item, index) in workerManager"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="驿站老师" prop="workerPostLeaderId">
              <el-select
                v-model="editInfo.workerPostLeaderId"
                style="width: 250px"
                placeholder="请选择驿站老师"
                filterable
              >
                <el-option
                  v-for="(item, index) in workerPostLeaders"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="银行卡号" prop="bankNo">
              <el-input
                :disabled="!ishz"
                type="number"
                v-model="editInfo.bankNo"
                style="width: 250px"
                placeholder="请输入银行卡号"
                clearable
                oninput="if(value.length>11)value=value.slice(0,24)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="开户行" prop="bankOfDeposit">
              <el-input
                :disabled="!ishz"
                v-model="editInfo.bankOfDeposit"
                style="width: 250px"
                placeholder="请输入开户行"
                clearable
                maxlength="40"
                minlength="10"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="备用手机1" prop="workerTel1">
              <el-input
                :disabled="!ishz"
                type="number"
                maxlength="11"
                style="width: 250px"
                v-model="editInfo.workerTel1"
                placeholder="请输入备用手机1"
                clearable
                oninput="if(value.length>11)value=value.slice(0,11)"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备用手机2" prop="workerTel2">
              <el-input
                :disabled="!ishz"
                type="number"
                style="width: 250px"
                v-model="editInfo.workerTel2"
                maxlength="11"
                oninput="if(value.length>11)value=value.slice(0,11)"
                placeholder="备用手机2"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="工作年限" prop="workingYears">
              <el-input
                type="number"
                style="width: 250px"
                v-model="editInfo.workingYears"
                placeholder="请输入工作年限"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="介绍" prop="introduce">
              <el-input
                type="textarea"
                maxlength="40"
                rows="3"
                show-word-limit
                style="width: 250px"
                v-model="editInfo.introduce"
                placeholder="请输入一句话介绍"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="紧急联系人" prop="emergencyContact">
              <el-input
                style="width: 250px"
                v-model="editInfo.emergencyContact"
                placeholder="请输入紧急联系人"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="紧急联系人电话"
              prop="emergencyTel"
              label-width="120px"
            >
              <el-input
                type="number"
                maxlength="11"
                oninput="if(value.length>11)value=value.slice(0,11)"
                v-model="editInfo.emergencyTel"
                placeholder="请输入紧急联系人电话"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="综合评分">
              <el-select
                v-model="editInfo.scoreLevel"
                style="width: 250px"
                placeholder="请选择"
                filterable
              >
                <template v-for="(item, index) in scoreLevelList">
                  <el-option :label="item" :value="item"></el-option>
                </template>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEdit = false">关闭</el-button>
        <el-button type="primary" @click="toUpdateInfo">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="修改来源"
      :visible.sync="showupdatesource"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form label-width="120px">
        <el-form-item label="来源类型" prop="sourceType">
          <el-radio-group
            v-model="updateSourceDto.sourceType"
            @change="chooseSourceType"
          >
            <el-radio :label="3">自招</el-radio>
            <el-radio :label="4">转介绍</el-radio>
            <el-radio :label="1">渠道</el-radio>
            <!-- <el-radio :label="6">自然流量</el-radio>  -->
            <el-radio :label="7">自有渠道</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="来源" prop="sourceRelationId">
          <el-select
            v-model="updateSourceDto.sourceRelationId"
            style="width: 100%"
            @change="sourceRelationChange"
            clearable
            placeholder="请选择来源"
            filterable
          >
            <template v-for="(item, index) in supplierList">
              <el-option
                v-if="item.sourceType == updateSourceDto.sourceType"
                :key="index"
                :label="item.name + item.id"
                :value="item.id"
              ></el-option>
            </template>
          </el-select>
          <div>*来源为服务者线索来源提供者，请如实填写</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showupdatesource = false">关闭</el-button>
        <el-button type="primary" @click="toUpdateSource">确定</el-button>
      </span>
    </el-dialog>
    <!-- 设置黑名单 -->
    <el-dialog
      title="设置黑名单"
      :visible.sync="showSetBlacklist"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <div class="blacklist-name">
        确定要将【{{ servantInfo.workerName }}】加入黑名单
      </div>
      <div class="blacklist-tips">不可移出黑名单，需联系总部移出</div>
      <div class="blacklist-warning">
        *拉黑后，阿姨立即下线，阿姨不可去其他门店入职，不允许接单与重新注册
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="canfSetBlacklist">关闭</el-button>
        <el-button type="primary" @click="confSetBlacklist">确定</el-button>
      </span>
    </el-dialog>

    <!--修改图片，头像-->
    <headPicPersonPic ref="headPicPersonPic" />

    <!--健康证，技能证书-->
    <workerHealthSkill ref="workerHealthSkill" />

    <!--选择服务者位置-->
    <selectWorkerAddress ref="selectWorkerAddress" />

    <!--身份证识别修改-->
    <idCardVerify ref="idCardVerify" />
  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination";
import workercrmapi from "@/script/api/workercrmapi";
import service from "@/script/api/service";
import wmsApi from "@/script/api/wmsApi";
import commutilData from "@/components/common/commutil.data";
import globalData from "@/components/common/globaldata/global.data.vue";
import headPicPersonPic from "@/components/workercrm/compent/headPicPersonPic.vue";
import workerHealthSkill from "@/components/workercrm/compent/workerHealthSkill.vue";
import selectWorkerAddress from "@/components/workercrm/compent/selectWorkerAddress.vue";
import idCardVerify from "@/components/workercrm/compent/idCardVerify.vue";

let vm;
export default {
  components: {
    Pagination,
    headPicPersonPic,
    workerHealthSkill,
    selectWorkerAddress,
    idCardVerify,
  },
  filters: {
    filterWorkerType(type) {
      if (type == 1) return "保洁";
      if (type == 2) return "保姆";
      if (type == 3) return "品类";
    },
  },
  data() {
    return {
      activeTab: "1",
      mentorList: [],
      residenceTypeMap: { 1: "农村", 2: "城镇" },
      socialSecurityMap: { 1: "社保", 2: "新农保", 3: "已退休", 4: "无" },
      healthState: { 0: "未上传", 1: "已上传", 2: "即将到期", 3: "已到期" },
      scoreLevelList: ["新人", "2星", "3星", "4星", "5星"],
      showupdatesource: false,
      updateSourceDto: {
        id: null,
        sourceType: null,
        sourceRelationId: null,
        sourceRelationName: null,
        operId: null,
        operName: null,
      },
      educationList: ["小学", "初中", "高中", "专科", "本科"],
      ishz: false,
      workerState: {
        1: "待上线",
        2: "已上线",
        3: "已解约",
        4: "复职",
        5: "入职失败",
      },
      workerSubState: {
        1: "背调失败",
        2: "培训淘汰",
        3: "拒绝入职",
        4: "入职审批拒绝",
      },
      serviceChannels: {
        1: "盒马",
        2: "私域",
        3: "公用",
      },
      workerManager: [],
      workerPostLeaders: [], //驿站老师
      cityList: [],
      postStationList: [],
      allStationList: [],

      openEditName: false,
      showEdit: false,
      editInfo: {
        id: null,
        workerName: null,
        buzLine: null,
        cityId: null,
        postStationId: null,
        stationId: null,
        bankNo: null,
        workerTel1: null,
        workerTel2: null,
        guaranteeAmount: null,
        guaranteeStart: null,
        guaranteeEnd: null,
        guaranteeDate: [],
        education: null,
        residenceType: null,
        socialSecurity: null,
        workerManagerId: "",
        workingYears: "",
        introduce: "",
        tags: [],
        emergencyContact: "",
        emergencyTel: "",
        scoreLevel: "",
      },
      commutilData: commutilData,

      editInfo_rules: {
        // workerTel1: [
        //     {
        //         validator: validatePhoneTwo,
        //         message: "手机号格式不对",
        //         trigger: "blur",
        //     },
        // ],
        // workerTel2: [
        //     {
        //         validator: validatePhoneTwo,
        //         message: "手机号格式不对",
        //         trigger: "blur",
        //     },
        // ],
        bankOfDeposit: [
          {
            min: 10,
            max: 40,
            message: "示例：中国工商银行上海张江镇支行",
            trigger: "blur",
          },
        ],
        buzLine: [
          { required: true, message: "请选择业务线", trigger: "change" },
        ],
        stationId: [
          { required: true, message: "请选择服务站", trigger: "change" },
        ],
      },
      id: null,
      workTypes: [
        { value: 1, label: "保洁" },
        { value: 2, label: "保姆" },
        { value: 3, label: "品类" },
      ],
      servantInfo: {
        cityDto: {},
      }, //线索内容
      workerInvestigate: {}, //背调信息
      workerMentor: {}, //师傅信息
      apprenticeList: [], //徒弟

      belongForm: {}, //归属及选择谁可见
      wmsOrder: [], //物料订单
      salary: [], //工资
      serviceOrder: [], //服务订单
      certificate: [],
      supplierList: [],
      blacklistValue: false,
      showSetBlacklist: false,
    };
  },
  watch: {
    $route(to, from) {
      if (from.path == "/myWorker" || from.path == "/workerList") {
        this.getServantDetail();
      }
    },
  },
  activated() {
    this.id = this.$route.query.id;
    this.activeTab = "1";
    this.getSupplierList();
    this.getServantDetail();
  },
  created() {
    // this.getSupplierList();
    // this.getServantDetail();
  },
  methods: {
  goUpdateName() {
      this.openEditName = true;
    },
    selectCity(v) {
      this.editInfo.stationId = "";
    },
    updateIdcard() {
      this.$refs.idCardVerify.addServantData(this.servantInfo);
    },
    getsplit(url) {
      if (url == null || url == "") {
        return [];
      }
      return url.split(",");
    },
    getsplitOne(url) {
      if (url == null || url == "") {
        return "";
      }
      console.log(url.split(",")[0]);
      return url.split(",")[0];
    },
    showWorkerAddress() {
      this.$refs.selectWorkerAddress.showWorkerAddress(this.servantInfo.id);
    },
    addhealthOrSKill(id) {
      //上传健康证或技能证书
      this.$refs.workerHealthSkill.handleHealth(id);
    },
    delSkillCert(row) {
      //删除技能证书
      this.$confirm("是否确认确认（若删除健康证，请及时重新上传）！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          workercrmapi
            .$axiosDeleteCertificate({
              id: row.id,
            })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.getServantDetail();
              }
            });
        })
        .catch((e) => {
          alert(e);
        });
    },
    goUpdateHeadPic() {
      //修改头像和个人图片
      this.$refs.headPicPersonPic.toUpdate(this.servantInfo);
    },
    getPersonImage() {
      //展示个人图片
      if (this.servantInfo.personPic && this.servantInfo.personPic != null) {
        return this.servantInfo.personPic.split(",");
      }
      return [];
    },
    toUpdateSource() {
      //修改来源
      workercrmapi
        .$axiosWorkerupdateSource(this.updateSourceDto)
        .then((res) => {
          if (res.data.errno == 0) {
            this.$message.success("修改成功");
            this.showupdatesource = false;
            this.getServantDetail();
          } else {
            this.$message.error(res.data.data);
          }
        });
    },
    sourceRelationChange(value) {
      //选择来源时拿到对应的id
      this.supplierList.forEach((item) => {
        console.log(item);
        if (
          item.id == value &&
          item.sourceType == this.updateSourceDto.sourceType
        ) {
          this.updateSourceDto.sourceRelationName = item.name;
        }
      });
    },
    chooseSourceType() {
      this.updateSourceDto.sourceRelationId = null;
      this.updateSourceDto.sourceRelationName = null;
    },
    updateSource() {
      this.showupdatesource = true;
      this.updateSourceDto = {
        id: this.servantInfo.id,
        sourceType: this.servantInfo.sourceType,
        sourceRelationId: this.servantInfo.sourceRelationId,
        sourceRelationName: this.servantInfo.sourceRelationName,
        operId: globalData.userInfo.id,
        operName: globalData.userInfo.userName,
      };
    },
    // openAppletRight(id) {
    //     console.log(id);
    //     this.$confirm("是否确认同步开通小程序商城账号？", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning"
    //     }).then(() => {
    //         workercrmapi.$axiosWorkerSyncOpenMall(
    //             { id: id }
    //         ).then(res => {
    //             this.$message({
    //                 type: "success",
    //                 message: "同步成功"
    //             })
    //         })
    //     })
    // },
    cancelzg() {
      this.$confirm("是否取消师傅资格？取消前需要解除名下徒弟关系", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          workercrmapi
            .$axiosworkerBaseCancelMaster({
              workerNo: this.servantInfo.workerNo,
              operName: globalData.userInfo.userName,
              operId: globalData.userInfo.id,
            })
            .then((res) => {
              if (res.data.errno == 0) {
                this.$message.success("操作成功");
                this.getServantDetail();
              } else {
                this.$message.error(res.data.data);
              }
            });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    goDormStaff() {
      // this.$router.push({
      //   path: "/dormStaff",
      //   query: {
      //     workerName: this.servantInfo.workerName,
      //   },
      // });
    },
    goSalary() {
      this.$router.push({
        path: "/salaryManage/salaryDetailList",
        query: {
          workerNo: this.servantInfo.workerNo,
        },
      });
    },
    goMentor() {
      this.$router.push({
        path: "/workermanager/lifeManager/workerMentor",
        query: {
          workerNo: this.servantInfo.workerNo,
        },
      });
      // workercrmapi.$ajaxqueryMentorRelate({workerNo:this.servantInfo.workerNo})
      //         .then((res) => {
      //             if (res.data.errno == 0) {
      //                 this.mentorList = res.data.data.list;
      //             }
      //         });
    },
    goWmsorderCenter() {
      this.$router.push({
        path: "/warehouseCenter/orderCenter",
        query: {
          workerNo: this.servantInfo.workerNo,
        },
      });
    },
    toUpdateInfo() {
      this.$refs["editInfo"].validate((valid) => {
        if (valid) {
          if (
            this.editInfo.guaranteeDate != null &&
            this.editInfo.guaranteeDate.length > 0
          ) {
            this.editInfo.guaranteeStart = this.editInfo.guaranteeDate[0];
            this.editInfo.guaranteeEnd = this.editInfo.guaranteeDate[1];
          } else {
            this.editInfo.guaranteeStart = null;
            this.editInfo.guaranteeEnd = null;
          }
          //驿站老师name值
          if (this.editInfo.workerPostLeaderId) {
            const leader = this.workerPostLeaders.find(
              (item) => item.id == this.editInfo.workerPostLeaderId
            );
            this.editInfo.workerPostLeader = leader ? leader.name : "";
          }

          this.editInfo.restDay = this.editInfo.restDays.join(",");
          this.editInfo.tag = this.editInfo.tags.join(",");
          workercrmapi
            .$axiosWorkerPerfectWorkerBase(this.editInfo)
            .then((res) => {
              if (res.data.errno == 0) {
                this.showEdit = false;
                this.$message.success("操作成功");
                this.getServantDetail();
              } else {
                this.$message.error(res.data.data);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editWorkerInfo(boo) {
      this.showEdit = true;
      this.ishz = boo; //是否可以换站
      //修改银行卡，手机号
      this.editInfo = {
        id: this.servantInfo.id,
        workerName: this.servantInfo.workerName,
        buzLine: this.servantInfo.buzLine,
        cityId: this.servantInfo.cityId,
        postStationId: this.servantInfo.postStationId,
        stationId: this.servantInfo.stationId,
        bankOfDeposit: this.servantInfo.bankOfDeposit,
        bankNo: this.servantInfo.bankNo,
        workerTel1: this.servantInfo.workerTel1,
        workerTel2: this.servantInfo.workerTel2,
        guaranteeAmount: this.servantInfo.guaranteeAmount,
        guaranteeStart: this.servantInfo.guaranteeStart,
        guaranteeEnd: this.servantInfo.guaranteeEnd,
        guaranteeDate: [],
        education: this.servantInfo.education,
        restDays:
          this.servantInfo.restDay == ""
            ? []
            : this.servantInfo.restDay.split(","),
        serviceChannel: this.servantInfo.serviceChannel,
        serviceOrderAllot: this.servantInfo.serviceOrderAllot,
        residenceType:
          this.servantInfo.residenceType == ""
            ? ""
            : this.servantInfo.residenceType + "",
        socialSecurity: this.servantInfo.socialSecurity,
        workerManagerId: this.servantInfo.workerManagerId,
        workerPostLeaderId: this.servantInfo.workerPostLeaderId,
        tags: this.servantInfo.tag.split(","),
        workingYears: this.servantInfo.workingYears,
        introduce: this.servantInfo.introduce,
        emergencyContact: this.servantInfo.emergencyContact,
        emergencyTel: this.servantInfo.emergencyTel,
      };
      console.log(this.editInfo);
      if (
        this.servantInfo.guaranteeStart != null &&
        this.servantInfo.guaranteeStart != "" &&
        this.servantInfo.guaranteeEnd != null &&
        this.servantInfo.guaranteeEnd != ""
      ) {
        this.editInfo.guaranteeDate.push(
          this.formateTime(this.servantInfo.guaranteeStart)
        );
        this.editInfo.guaranteeDate.push(
          this.formateTime(this.servantInfo.guaranteeEnd)
        );
      }

      this.getAllCity();
      // this.getAllPostStation(); //驿站
      this.getAllStationList();
      this.getWorkerManager();
      this.getWorkerPostLeader();
    },
    getServantDetail() {
      workercrmapi
        .$axiosGetWorkerInfo({
          workerSupplierId: this.id,
          workerNo: this.$route.query.workerNo,
        })
        .then((res) => {
          this.servantInfo = res.data.data.worker;
          this.ticketInfo = res.data.data.ticket;
          this.wmsOrder = res.data.data.wmsOrderList;
          this.certificate = res.data.data.certificate;
          this.salary = res.data.data.salary;
          this.serviceOrder = res.data.data.serviceOrder;
          this.workerMentor = res.data.data.workerMentor;
          this.apprenticeList = res.data.data.apprenticeList;
          this.workerInvestigate = res.data.data.workerInvestigate;
          this.blacklistValue = res.data.data.isBlack;
        });
    },

    handleSkillChange(value) {
      if (value.length > 0) {
        this.upgradeForm.skillGroupId = value[0];
        this.upgradeForm.userId = value[1];
      }
      console.info(value);
    },
    workerBelongChange(value) {
      this.supplierList.forEach((item) => {
        if (item.id == value)
          this.updateClue.workerBelongName = item.franchiseeName;
      });
    },
    // sourceRelationChange(value) {
    //     this.supplierList.forEach((item) => {
    //         if (item.id == value)
    //             this.updateClue.sourceRelationName = item.franchiseeName;
    //     });
    // },
    cityChange(value) {
      this.cityList.forEach((item) => {
        if (item.id == value) this.updateClue.cityName = item.cityName;
      });
    },
    getAllCity() {
      //城市下拉框
      wmsApi.$axiosgetallCity().then((res) => {
        if (res.data.errno == 0) {
          this.cityList = res.data.data;
        }
      });
    },
    getAllPostStation() {
      workercrmapi.$axiosPostStationgetAllList().then((res) => {
        if (res.data.errno == 0) {
          this.postStationList = res.data.data;
        }
      });
    },

    getAllStationList() {
      //服务站
      wmsApi.$axiosGetAllStationList().then((res) => {
        if (res.data.errno == 0) {
          this.allStationList = res.data.data;
        }
      });
    },
    getSkillGroup() {
      //获取技能组
      workercrmapi.$axiosGetSkillGroup().then((res) => {
        let skills = [];
        if (res.data.errno == 0 && res.data.data.length > 0) {
          res.data.data.forEach((item) => {
            item.userList.forEach((user) => {
              user.name = user.userName;
            });
            skills.push(item);
          });
        }
        this.skillGroups = skills;
      });
    },
    getWorkerManager() {
      //获取所有商家运营
      if (this.workerManager.length > 0) return;
      workercrmapi.$axiosWorkerManagerAll().then((res) => {
        this.workerManager = res.data.data;
      });
    },
    getWorkerPostLeader() {
      if (this.workerPostLeaders.length > 0) return;
      workercrmapi.$axiosWorkerPostLeaderAll().then((res) => {
        this.workerPostLeaders = res.data.data;
      });
    },
    getSupplierList() {
      //获取归属
      workercrmapi
        .$axiosGetSupplierList({ companyId: globalData.company.id })
        .then((res) => {
          this.supplierList = res.data.data;
        });
    },
    getSysUser() {
      //城市下拉框
      service.$axiosSysUsergetallUser().then((res) => {
        if (res.data.errno == 0) {
          this.sysUserList = res.data.data;
        }
      });
    },
    fmtDateT(date) {
      if (date == null || date == "") {
        return null;
      }
      var dateString = new Date(date);
      var dt = new Date(date)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
      // 注意js里面的getMonth是从0开始的
      // let formattedDateTime =
      //     dateString.getFullYear() +
      //     "-" +
      //     (dateString.getMonth() + 1) +
      //     "-" +
      //     dateString.getDate() +
      //     " " +
      //     dateString.getHours() +
      //     ":" +
      //     dateString.getMinutes() +
      //     ":" +
      //     dateString.getSeconds();

      return dt;
    },
    blacklistValueChange() {
      if (this.blacklistValue) {
        this.showSetBlacklist = true;
      } else {
        workercrmapi
          .$axiosCancelBlacklist({
            id: this.servantInfo.id,
            operName: globalData.userInfo.userName,
            operId: globalData.userInfo.id,
          })
          .then((res) => {
            if (res.data.errno == 0) {
              this.getServantDetail();
              this.$message.success("取消黑名单成功");
            } else {
            }
          });
      }
    },
    canfSetBlacklist() {
      this.showSetBlacklist = false;
      this.blacklistValue = false;
    },

    confSetBlacklist() {
      workercrmapi
        .$axiosSetBlacklist({
          id: this.servantInfo.id,
          operName: globalData.userInfo.userName,
          operId: globalData.userInfo.id,
        })
        .then((res) => {
          // console.log("res", res);
          if (res.data.errno == 0) {
            this.disabled = true;
            this.showSetBlacklist = false;
            this.getServantDetail();
            this.$message.success("加入黑名单成功");
          } else {
            this.$message.error("操作失败");
          }
        });
    },
  },
  beforeCreate() {
    vm = this;
  },
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}

.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}

.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}

.detail-container {
  width: 80%;
  padding: 20px 20px 20px 20px;
  margin: 20px auto;
}

.operate-container {
  background: #f2f6fc;
  height: 80px;
  margin: -20px -20px 0;
  line-height: 80px;
}

.operate-button-container {
  float: right;
  margin-right: 20px;
}

.table-layout {
  margin-top: 10px;
  border-left: 1px solid #dcdfe6;
  border-top: 1px solid #dcdfe6;
}

.table-cell {
  line-height: 19px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 12px;
  font-size: 14px;
  color: #606266;
  text-align: center;
  white-space: pre-wrap;
  /* overflow: hidden; */
  height: 43px;
}

.table-cell-title {
  height: 43px;
  border-right: 1px solid #dcdfe6;
  border-bottom: 1px solid #dcdfe6;
  padding: 12px;
  background: #f2f6fc;
  text-align: center;
  font-size: 14px;
  color: #303133;
  font-weight: 650;
}

.el-table th.gutter {
  display: table-cell !important;
}

.el-button + .el-button {
  margin-left: 0px;
}

.el-table colgroup.gutter {
  display: table-cell !important;
}

.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}

.color-danger {
  color: #f56c6c;
  font-size: 18px;
}

.el-dialog .el-cascader {
  width: 400px;
}

.fixed-width .el-button--mini {
  width: auto;
  min-width: 60px;
}

.el-step.is-center .el-step__description {
  padding-left: 18%;
  padding-right: 18%;
}

.el-table th.gutter {
  display: table-cell !important;
}
.blacklist-name {
  font-size: 18px;
  font-weight: bold;
  text-align: center;
}
.blacklist-tips {
  font-size: 14px;
  color: #aca756;
  text-align: center;
  margin: 20px auto;
}
.blacklist-warning {
  font-size: 14px;
  color: red;
  text-align: center;
}
</style>
